import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'ion-password-rule',
  standalone: true,
  imports: [TuiIcon, TranslateModule],
  template: `
    <div class="rule flex gap-xxs" [class.ok]="isActive() && !invalid()" [class.nok]="showError() && invalid()">
      <tui-icon class="rule-icon" [icon]="invalid() ? '@tui.shield-alert' : '@tui.check'"></tui-icon>
      <span>{{ labelKey() | translate }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./password-rule.component.scss'],
})
export class PasswordRuleComponent {
  readonly labelKey = input<string>('');
  readonly invalid = input<boolean>(false);
  readonly showError = input<boolean>(false);
  readonly isActive = input<boolean>(false);
}
